/**
 * Announcement banner dismissal.
 *
 * The banner itself is rendered server-side; this only handles the close button.
 * Hiding on later page views is done by the inline pre-paint script printed in
 * template-parts/announcement-banner.php, which keeps the behaviour correct
 * behind WP Rocket's page cache and avoids any flash of the closed banner.
 */

document.addEventListener('DOMContentLoaded', function () {
    const banner = document.querySelector('[data-dg-announcement]');

    if (!banner) {
        return;
    }

    const dismissButton = banner.querySelector('[data-dg-announcement-dismiss]');

    if (!dismissButton) {
        return;
    }

    dismissButton.addEventListener('click', function () {
        const version = banner.getAttribute('data-version') || '1';
        const days = parseInt(banner.getAttribute('data-days'), 10) || 30;
        const expires = new Date(Date.now() + days * 864e5).toUTCString();
        const secure = window.location.protocol === 'https:' ? '; secure' : '';

        document.cookie = `_dg_ab=${version}; expires=${expires}; path=/; samesite=lax${secure}`;

        document.documentElement.classList.add('dg-banner-dismissed');
        banner.remove();

        // Fixed-position menu panels are offset from the header bottom edge.
        window.dispatchEvent(new Event('resize'));
    });
});
